export default __webpack_public_path__ + "8a470effbe9dfa369223b88781ec3042.svg";